import { FILTERS, DEFAULT_FILTER_OPTIONS } from '../../../../../common/filters/constants';
import { getBeginningOfDay } from '../../../../../../constants/helpers/dates';

import { CustomerAuthenticationBillingFilters } from './interfaces';

export const CUSTOMER_AUTHENTICATION_PROVIDERS = ['FBN_USSD'];

export const CUSTOMER_AUTHENTICATION_METHODS = ['USSD_PIN', 'CARD_PIN', 'USSD_PIN_AND_CARD_PIN'];

export const initFilters: CustomerAuthenticationBillingFilters = {
  [FILTERS.PAGE_SIZE]: DEFAULT_FILTER_OPTIONS.PAGE_SIZE,
  [FILTERS.FROM]: getBeginningOfDay(),
  [FILTERS.TO]: 'now',
  [FILTERS.OPERATION_ID]: [],
  [FILTERS.STATUS]: [],
  [FILTERS.CUSTOMER_MSISDN]: [],
  [FILTERS.PROVIDER_NAME]: [],
  [FILTERS.AUTHENTICATION_METHOD]: []
};

export const activeFiltersCountMapper = (activeFilters: CustomerAuthenticationBillingFilters) => {
  let availableFiltersCount = 0;

  if (activeFilters.operation_id?.length > 0) {
    availableFiltersCount += 1;
  }

  if (activeFilters.status?.length > 0) {
    availableFiltersCount += 1;
  }

  if (activeFilters.customer_msisdn?.length > 0) {
    availableFiltersCount += 1;
  }

  if (activeFilters.provider_name?.length > 0) {
    availableFiltersCount += 1;
  }

  if (activeFilters.authentication_method?.length > 0) {
    availableFiltersCount += 1;
  }

  return availableFiltersCount;
};
